import { markersPlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { isDownFractal, isUpFractal } from "../math/fractals";

/**
 * Fractal (research §1.4), as TV Williams Fractals: an arrowhead over the
 * high of an up fractal and under the low of a down one (as in PO), at the
 * fractal bar itself.
 * Values are the high / low of the fractal bar, NaN elsewhere; the last
 * `period` bars have no fractal yet (their right side is not complete).
 */
export default {
  id: "fractal",
  name: "Fractal",
  isOscillator: false,
  inputs: [
    periodInput("period", "Period", 2, { min: 2, max: 100 }),
  ],
  plots: [
    markersPlot("up", "Up", PALETTE.LIME, true),
    markersPlot("down", "Down", PALETTE.RED, false),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    // A new or moved bar decides the fractals of the `period` bars before it
    const firstCentre = Math.max(0, fromIndex - period);

    for (let centre = firstCentre; centre < bars.length; centre += 1) {
      series.up[centre] = isUpFractal(bars, centre, period) ? bars[centre].high : NaN;
      series.down[centre] = isDownFractal(bars, centre, period) ? bars[centre].low : NaN;
    }

    return firstCentre;
  },
};
